import { useQuery } from '@tanstack/react-query';
import { mockJourneys, Journey } from '@mocks/journeys';
import { queryKeys } from '../queryKeys';

// Mock API call - in production, this would call the real API
const fetchJourneys = async (): Promise<Journey[]> =>
  new Promise(resolve => {
    setTimeout(() => resolve(mockJourneys), 500);
  });

export const useJourneys = () =>
  useQuery({
    queryKey: queryKeys.journeys,
    queryFn: fetchJourneys,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

const fetchJourney = async (id: string): Promise<Journey | undefined> =>
  new Promise(resolve => {
    setTimeout(() => {
      const journey = mockJourneys.find(j => j.id === id);
      resolve(journey);
    }, 300);
  });

export const useJourney = (id: string) =>
  useQuery({
    queryKey: queryKeys.journey(id),
    queryFn: () => fetchJourney(id),
    staleTime: 5 * 60 * 1000,
  });
